/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Measure_Unit_Request_OtherInputs */

const en_measure_unit_request_other = /** @type {(inputs: Measure_Unit_Request_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} requests`)
};

const zh_hans1_measure_unit_request_other = /** @type {(inputs: Measure_Unit_Request_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 次请求`)
};

const pt_br2_measure_unit_request_other = /** @type {(inputs: Measure_Unit_Request_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} requisições`)
};

const es_measure_unit_request_other = /** @type {(inputs: Measure_Unit_Request_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} solicitudes`)
};

const fr_measure_unit_request_other = /** @type {(inputs: Measure_Unit_Request_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} requêtes`)
};

const de_measure_unit_request_other = /** @type {(inputs: Measure_Unit_Request_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Anfragen`)
};

const ru_measure_unit_request_other = /** @type {(inputs: Measure_Unit_Request_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Запросов: ${i?.count}`)
};

const it_measure_unit_request_other = /** @type {(inputs: Measure_Unit_Request_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} richieste`)
};

/**
* | output |
* | --- |
* | "{count} requests" |
*
* @param {Measure_Unit_Request_OtherInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_request_other = /** @type {((inputs: Measure_Unit_Request_OtherInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Request_OtherInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_request_other(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_request_other(inputs)
	if (locale === "es") return es_measure_unit_request_other(inputs)
	if (locale === "fr") return fr_measure_unit_request_other(inputs)
	if (locale === "de") return de_measure_unit_request_other(inputs)
	if (locale === "ru") return ru_measure_unit_request_other(inputs)
	if (locale === "it") return it_measure_unit_request_other(inputs)
	return en_measure_unit_request_other(inputs)
});